import { render } from "./PbschoolTable.vue?vue&type=template&id=ee072666&scoped=true"
import script from "./PbschoolTable.vue?vue&type=script&lang=js"
export * from "./PbschoolTable.vue?vue&type=script&lang=js"

import "./PbschoolTable.vue?vue&type=style&index=0&id=ee072666&scoped=true&lang=css"

import exportComponent from "D:\\newProjectGit\\HbzsbAdminClient\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ee072666"]])

export default __exports__